module.exports = __webpack_public_path__ + "img/img08.5a116328.jpeg";